import { Platform } from 'react-native'
import { Extrapolation, interpolate, type SharedValue, useAnimatedStyle } from 'react-native-reanimated'

import { useDimensions } from '@/src/general/hooks/useDimensions'

import { HEADER_TRANSLATE_Y, useHeaderTranslateY } from './useListAnimatedScroll'

const HEADER_HEIGHT = Platform.OS === 'web' ? 420 : 400
const COMPACT_SIZE = Platform.OS === 'web' ? 48 : 40
export const WEB_TRANSLATE_IMAGE_Y = Platform.OS === 'web' ? 360 : 350

const getCompactHeaderScales = (width: number, height: number, compactSize: number) => ({
  scaleX: compactSize / width,
  scaleY: compactSize / height,
})

export const useAnimatedHeader = (offsetY: SharedValue<number>) => {
  const { width: windowWidth } = useDimensions()
  const translateY = useHeaderTranslateY()

  const { scaleX: compactScaleX, scaleY: compactScaleY } = getCompactHeaderScales(
    windowWidth,
    HEADER_HEIGHT,
    COMPACT_SIZE,
  )
  const imageAnimatedStyle = useAnimatedStyle(() => {
    const scaleX = interpolate(offsetY.get(), [-translateY, 0], [compactScaleX, 1], Extrapolation.CLAMP)
    const scaleY = interpolate(offsetY.get(), [-translateY, 0], [compactScaleY, 1], Extrapolation.CLAMP)

    return {
      transformOrigin: 'top left',
      transform: [
        {
          translateY: interpolate(offsetY.get(), [-translateY, 0], [WEB_TRANSLATE_IMAGE_Y, 0], Extrapolation.CLAMP),
        },
        { translateX: interpolate(offsetY.get(), [-translateY, 0], [16, 0], Extrapolation.CLAMP) },
        { scaleX },
        { scaleY },
      ],

      borderTopRightRadius: interpolate(
        offsetY.get(),
        [-HEADER_TRANSLATE_Y, 0],
        [8 / compactScaleX, 0],
        Extrapolation.CLAMP,
      ),
      borderTopLeftRadius: interpolate(
        offsetY.get(),
        [-HEADER_TRANSLATE_Y, 0],
        [8 / compactScaleX, 0],
        Extrapolation.CLAMP,
      ),
      borderBottomLeftRadius: interpolate(
        offsetY.get(),
        [-HEADER_TRANSLATE_Y, 0],
        [8 / compactScaleX, 20],
        Extrapolation.CLAMP,
      ),
      borderBottomRightRadius: interpolate(
        offsetY.get(),
        [-HEADER_TRANSLATE_Y, 0],
        [8 / compactScaleX, 20],
        Extrapolation.CLAMP,
      ),
    }
  })

  const opacityAnimatedStyle = useAnimatedStyle(() => ({
    opacity: interpolate(offsetY.get(), [-10, 0], [0, 1], Extrapolation.CLAMP),
  }))

  return { opacityAnimatedStyle, imageAnimatedStyle }
}
